module.exports = __webpack_public_path__ + "img/history-tab-inactive.5c129585.svg";